<template>
	<div ref="button" class="underwrite" @mouseenter="show(true)" @mouseleave="show(false)">
		<div><slot></slot> <i class="tf tf-tri-down"></i></div>
		
		<div v-if="type" v-show="showMore">
			<div v-if="typeList.length" class="list" :style="moreListPosition">
				<div v-for="(item, i) in typeList" :key="i" class="item">
					<p @click="handle(type, item.id)">{{item.name}}</p>
				</div>
			</div>
		</div>
		
		<div v-else v-show="showMore" class="list" :style="moreListPosition">
			<div v-for="(type, i) in typeList" :key="i" class="item" @mouseenter="getInsurance(type)">
				<p>{{type.type_name}}</p>
				
				<ul v-if="type.list && type.list.length" class="list">
					<li v-for="(item, j) in type.list" :key="j" class="item"><p @click="handle(type.type_id, item.id)">{{item.name}}</p></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			projectId: [String, Number],
			type: [String, Number]
		},
		
		data() {
			return {
				typeList: [],
				showMore: false,
				moreListPosition: {}
			}
		},
		
		mounted() {
			if (this.type) {
				this.request({
					url: '/bxgs/list',
					data: {
						type_id: this.type
					},
					success: data => {
						this.typeList = data;
					}
				});
			} else {
				this.request({
					url: '/bx_type/list',
					success: data => {
						this.typeList = data;
					}
				});
			}
		},
		
		methods: {
			getInsurance(item) {
				if (item.list) return;
				this.request({
					url: '/bxgs/list',
					data: {
						type_id: item.type_id
					},
					success: data => {
						this.$set(item, 'list', data);
					}
				});
			},
			
			show(state) {
				if (state) {
					this.moreListPosition = {
						left: this.type ? 'auto' : ($(this.$refs.button).offset().left + 'px'),
						right: this.type ? ($(window).width() - $(this.$refs.button).offset().left - $(this.$refs.button).innerWidth() + 'px') : 'auto',
						top: $(this.$refs.button).offset().top + $(this.$refs.button).innerHeight() - window.scrollY + 'px'
					}
					this.showMore = true;
				} else {
					this.showMore = false;
				}
			},
			
			handle(type, id) {
				this.navigateTo('/transact/insurance/apply', {type, companyId: id, projectId: this.projectId || ''}, true);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.underwrite {
		display: inline-block;
		position: relative;
		height: 32px;
		padding: 0 10px;
		line-height: 32px;
		font-size: 14px;
		color: #fff;
		background: #1492FF;
		cursor: pointer;
		
		&:hover {
			background: #117CD9;
		}
		
		.list {
			z-index: 99;
			position: absolute;
			left: 0;
			top: 0;
			min-width: 150px;
			padding: 4px 0;
			background: #fff;
			box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
			
			.item {
				&:hover > p{
					color: #1492FF;
					background: #F2F4F7;
				}
				
				p {
					padding: 8px 12px;
					line-height: 20px;
					font-size: 14px;
					white-space: nowrap;
					color: #333;
				}
			}
		}
		
		div.list {
			position: fixed;
			
			.item {
				position: relative;
				
				&:hover ul {
					display: block;
				}
				
				ul {
					display: none;
					left: 100%;
					top: 0;
				}
			}
		}
	}
</style>
